import {
  container,
  cardTitle,
  whiteColor,
  grayColor,
  roseColor,
  hexToRgb,
  blackColor,
  primaryColor,
} from "assets/jss/material-dashboard-pro-react.js";

import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

const clockInPageStyle = (theme) => ({
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  left: {
    textAlign: "left",
  },
  ...buttonStyle,

  checkinHeader: {
    textAlign: "center",
  },
  codeField: {
    width: "40px",
    fontWeight: "bold",
    fontSize: "25px",
    marginRight: "10px",
    paddingLeft: "12px",
    height: "40px",
  },
  submitBtn: {
    marginTop: "30px",
  },
  clockInContainer: {
    textAlign: "center",
  },
  loginBtn: {
    marginTop: "20px",
  },
  clockInPadContainer: {
    textAlign: "center",
    paddingTop: "20px",
  },
  info: {
    textAlign: "center",
    paddingTop: "10px",
    fontSize: "13px",
    fontWeight: "bold",
    backgroundColor: "transparent",
  },
  checkinTable: {
    marginTop: "20px",
  },
  iconCheckbox: {},
  iconCheckboxIcon: {
    fontSize: "40px",
  },
  errorMsg: {
    color: "#de4463",
  },
  marginDown: {
    marginBottom: "20px",
  },
  iconCheckboxChecked: {
    color: roseColor[0],
    "& > span:first-child": {
      borderColor: roseColor[0],
    },
  },
  checkinButton: {
    marginTop: "20px",
    fontSize: "25px",
    borderRadius: "10px",
  },
  appBar: {
    marginBottom: "30px",
  },
  serviceSelection: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "20px",
    textDecoration: "underline",
  },
  serviceError: {
    textAlign: "center",
    fontSize: "12px",
    color: "red",
  },
  choice: {
    textAlign: "center",
    cursor: "pointer",
    marginTop: "20px",
  },
  title: {
    fontWeight: "bold",
    fontSize: "35px",
    color: "#1cabe0",
  },
  subTitle: {
    // marginTop: "-5px",
    fontWeight: "500",
    fontSize: "25px",
    color: "#EEA47FFF",
  },
  dialogContent: {
    // marginTop: "20px",
    fontSize: "16px",
    fontWeight: "400",
  },
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(2),
      // width: 300,
    },
  },
  imgLogo: {
    // objectFit: "cover",
    width: "100%",
    maxHeight: "100%",
  },
  container: {
    backgroundColor: "#294b59",
    "@media (min-width:320px)": {
      maxWidth: "90%",
    },
    "@media (min-width:481px)": {
      maxWidth: "85%",
    },
    "@media ((min-width:641px))": {
      maxWidth: "40%",
    },
    "@media (min-width:961px)": {
      width: "50%",
    },
    "@media (min-width:1025px)": {
      width: "50%",
    },
    paddingBottom: "20px",
    ...container,
    border: "5px solid",
    borderColor: "#6d7d84",
    borderRadius: "20px",
    boxShadow: "20px 20px 50px 15px #4c5254",
    shadowColor: "black",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px",
    },
  },
  resetPass: {
    fontStyle: "italic",
    fontFamily: "Dancing Script",
  },
  cardTitle: {
    ...cardTitle,
    color: whiteColor,
  },
  titleContainer: {
    textAlign: "center",
    marginTop: "20px",
  },
  checkInOption: {
    textAlign: "center",
  },
  textCenter: {
    textAlign: "center",
  },
  justifyContentCenter: {
    justifyContent: "center !important",
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: whiteColor,
    },
    marginLeft: "5px",
    marginRight: "5px",
  },
  inputAdornment: {
    marginRight: "18px",
  },
  inputAdornmentIcon: {
    color: grayColor[6],
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)",
  },
  cardHeader: {
    marginBottom: "20px",
  },
  socialLine: {
    padding: "0.9375rem 0",
  },
  labelHorizontal: {
    color: `rgba(${hexToRgb(blackColor)}, 0.5)`,
    cursor: "pointer",
    fontSize: "30px",
    lineHeight: "2",
    fontWeight: "500",
    marginRight: "0",
    textAlign: "center",
  },
  label: {
    color: `rgba(${hexToRgb(blackColor)}, 0.5)`,
  },
  labelHorizontalRadioCheckbox: {
    paddingTop: "22px",
  },
  inlineChecks: {
    marginTop: "8px",
  },
  radioChecked: {
    width: "16px",
    height: "16px",
    border: `1px solid ${primaryColor[0]}`,
    borderRadius: "50%",
  },
  radioUnchecked: {
    width: "0px",
    height: "0px",
    padding: "7px",
    border: `1px solid rgba(${hexToRgb(blackColor)}, .54)`,
    borderRadius: "50%",
  },
  radio: {
    color: `${primaryColor[0]}!important`,
  },
  radioRoot: {
    padding: "16px",
    "&:hover": {
      backgroundColor: "unset",
    },
  },
  loginOption: {
    display: "flex",
    justifyContent: "center !important",
  },
  ...buttonStyle,
});

export default clockInPageStyle;
